/* eslint-disable import/prefer-default-export */
const getEnv = (k) => window._env_?.[k] ?? process.env[k];

export async function uploadCaseDocuments({ message, threadId, agentConfigName }) {
  window.dispatchEvent(new Event('api-activity'));
  const base = getEnv('REACT_APP_AGENTIC_API_BASE_URL') || '';
  const code = getEnv('REACT_APP_AGENTIC_API_CODE');
  const response = await fetch(`${base}/api/intake-review/chat?code=${code}`, {
    method: 'POST',
    headers: {
      Accept: '*/*',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      message,
      thread_id: threadId,
      agent_name: agentConfigName.agent_name,
    }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || 'Failed to upload documents');
  }

  return response.json();
}
